import { Paper, Table, TableContainer } from '@mui/material'
import { InternalHoursLog } from '@/types'
import { InternalHoursLogsTableHead } from './InternalHoursLogsTableHead'
import { InternalHoursLogsTableBody } from './InternalHoursLogsTableBody'

export type InternalHoursLogsTableProps = {
  rows: InternalHoursLog[]
  onOpenDetails: (id: number) => void
}

export const InternalHoursLogsTable = ({
  rows,
  onOpenDetails,
}: InternalHoursLogsTableProps): JSX.Element => (
  <TableContainer component={Paper}>
    <Table stickyHeader={true}>
      <InternalHoursLogsTableHead />
      <InternalHoursLogsTableBody rows={rows} onOpenDetails={onOpenDetails} />
    </Table>
  </TableContainer>
)
